import React from 'react';
import { Users, Inbox, MessageSquare, Briefcase, Film, FileText, AlertCircle, Clock, Activity } from 'lucide-react';
import SubmissionAnalytics from './SubmissionAnalytics';

const StatCard = ({ icon, label, value, subValue, alert }) => (
  <div className="bg-swp-surface border border-swp-border rounded-swp p-4">
    <div className="flex items-center gap-3 mb-2">
      {icon}
      <span className="text-swp-white-ghost text-sm">{label}</span>
    </div>
    <p className="text-3xl font-bold text-white">{value}</p>
    <p className={`text-xs mt-1 ${alert ? 'text-yellow-400' : 'text-swp-white-ghost/70'}`}>
      {alert && <AlertCircle size={12} className="inline mr-1" />}
      {subValue}
    </p>
  </div>
);

const DashboardOverview = ({ stats, activityItems, formatTimeAgo, onViewAllActivity, getActivityIcon }) => (
  <>
    {/* Stats Grid */}
    <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-8">
      <StatCard icon={<Users className="text-green-400" />} label="Subscribers" value={stats?.total_subscribers || 0} subValue={`+${stats?.new_subscribers_30d || 0} this month`} />
      <StatCard icon={<Inbox className="text-blue-400" />} label="Submissions" value={stats?.total_submissions || 0} subValue={`${stats?.pending_submissions || 0} pending`} alert={stats?.pending_submissions > 0} />
      <StatCard icon={<MessageSquare className="text-purple-400" />} label="Messages" value={stats?.total_messages || 0} subValue={`${stats?.pending_messages || 0} new`} alert={stats?.pending_messages > 0} />
      <StatCard icon={<Briefcase className="text-yellow-400" />} label="Investor Inquiries" value={stats?.total_investor_inquiries || 0} subValue="Total received" />
    </div>

    {/* Content Stats */}
    <div className="grid grid-cols-2 gap-4 mb-8">
      <StatCard icon={<Film className="text-red-400" />} label="Films" value={stats?.total_films || 0} subValue="In catalog" />
      <StatCard icon={<FileText className="text-cyan-400" />} label="Blog Posts" value={stats?.total_blog_posts || 0} subValue="Published" />
    </div>

    {/* Scrypto Analytics */}
    <SubmissionAnalytics />

    {/* Quick Activity Preview */}
    <div className="bg-swp-surface border border-swp-border rounded-swp p-6">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-semibold text-white flex items-center gap-2">
          <Clock size={18} className="text-swp-ice" />
          Recent Activity
        </h3>
        <button onClick={onViewAllActivity} className="text-swp-ice text-sm hover:underline">View All</button>
      </div>
      {activityItems.length === 0 ? (
        <p className="text-swp-white-ghost/70 text-center py-8">No recent activity</p>
      ) : (
        <div className="space-y-3">
          {activityItems.slice(0, 5).map((activity) => (
            <div key={activity.id || `act-${activity._type}-${activity.created_at}`} className="flex items-center gap-3 py-2 border-b border-swp-border/50 last:border-0">
              <div className="w-8 h-8 rounded-sm bg-swp-deep/70 flex items-center justify-center">
                {getActivityIcon(activity._type)}
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-white text-sm truncate">{activity.name} - {activity._type}</p>
              </div>
              <span className="text-swp-white-ghost/70 text-xs whitespace-nowrap">{formatTimeAgo(activity.created_at)}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  </>
);

export default DashboardOverview;
